import {Act} from "@/backing/interfaces/backing";

export default function (apiClient) {
    return {
        async index(): Promise<Act[]> {
            return apiClient.get("acts")
                .then(response => response.data.data);
        }
    };
}
